import DialogUserSendMailLockedContent from '~/components/dialog/user/DialogUserSendMailLockedContent.vue';
import DialogLockedContent from '~/components/dialog/locked/DialogLockedContent.vue';

export type DialogLockedContent = {
  title: string;
  description: number;
  appEventShare: UseAppEventShare;
};

export const useDialogLockedContent = () => {
  const dialog = useDialogStore();

  const profile = useProfileStore();

  const open = (
    type?: string,
    backUrl: string = null,
    onClose: () => void = null,
    appEventShare?: UseAppEventShare
  ) => {
    dialog.open(DialogLockedContent, {
      level: DialogLevel.Info,
      type,
      appEventShare,
      backUrl,
      onOpenSendMail: () => {
        dialog.close();
        openDialogSendMail(type, backUrl, onClose, appEventShare);
      },
      onClose: () => {
        if (backUrl) navigateTo(backUrl);
        if (onClose) onClose();
      },
    });
  };

  const openDialogSendMail = async (
    type?: string,
    backUrl?: string,
    onClose?: () => void,
    appEventShare?: UseAppEventShare
  ) => {
    return new Promise<void>((resolve) => {
      dialog.close();

      dialog.open(DialogUserSendMailLockedContent, {
        type,
        level: DialogLevel.Info,
        titleHtml: '💌 Aucun parent ne nous résiste !',
        descriptionHtml:
          'Mets le mail de tes parents : ils te prendront <strong>NOMAD+</strong> direct 💯',
        descriptionSendMailCompleteHtml: "L'invitation a bien été envoyée",
        defaultEmail: profile.parentInfo.email,
        data: {},
        sourceLocation: 'content',
        appEventShare,
        forced: false,
        cancel: true,
        labelCancel: 'Retour',
        onClose: () => {
          if (backUrl) navigateTo(backUrl);
          if (onClose) onClose();
          resolve();
        },
        onCancel: () => {
          dialog.close();
          open(type, backUrl, onClose, appEventShare);
        },
      });
    });
  };

  const close = () => {
    dialog.close();
  };

  return {
    open,
    close,
  };
};
